import styles from './Forgot.scss';
import { ForgetFormValues, ForgotForm } from '@/components/organisms/form/ForgotForm';
import { pagesPath } from '@/lib/$path';
import Link from 'next/link';
import { useAuthContext } from '@/hooks/auth';
import { useRouter } from 'next/dist/client/router';
import { useForm } from 'react-hook-form';

/** organizers/Forgot */
export const Forgot: React.FC = () => {
  const router = useRouter();
  const authCtx = useAuthContext();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<ForgetFormValues>({ reValidateMode: 'onSubmit' });

  const forgot = handleSubmit(async (params: Parameters<typeof authCtx.forgot>[0]) => {
    await authCtx.forgot(params);
    router.push(pagesPath.reset_password.request_confirmed.$url());
  });

  return (
    <>
      <main className="forgot">
        <div className="forgot__inner">
          <h1 className="forgot__h1">パスワードを再設定する</h1>
          <ForgotForm onSubmit={forgot} register={register} errors={errors} />
          <ul className="forgot__menu ">
            <li>
              <Link href={pagesPath.sign_up.$url({ query: { referrer: router.asPath } })}>
                <a>アカウントを作成する</a>
              </Link>
            </li>
            <li>
              <Link href={pagesPath.sign_in.$url({ query: { referrer: router.asPath } })}>
                <a>ログインする</a>
              </Link>
            </li>
          </ul>
        </div>
      </main>
      <style jsx>{styles}</style>
    </>
  );
};
